import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const parentTrialsApi = {
    getParentTrials: (): Observable<Dtos.GetParentTrialsResponse> => {
        //Create the request.
        let request: Dtos.GetParentTrials = new Dtos.GetParentTrials();

        //Send request.
        const response: Promise<Dtos.GetParentTrialsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}